import { min } from "class-validator";

export class SaleOrderItemsDto {
    saleOrderItemId: number;
    saleOrderId: number;
    itemId: string;
    minGrade: number;
    maxGrade: number;
    foodTypeId: string;
    valueAdditionOneId: number;
    valueAdditionTwoId: number;
    valueAdditionThreeId: number;
    valueAdditionFourId: number;
    cases: number;
    netAmount: number;
    unitPrice: number;
    pouches: number;
    pouchWeight: number;
    caseWeight: string;
    categoryId: number;
    netWeight: string;
    freezeStle: number;
        minGlaze: number;
        MaxGlaze: number;
        soakingTime: string;
        soakingStyle: string;
        styleWeighment: string;
        varientId: string;
    isActive: boolean;
    createdAt: Date;
    createdUser: string;
    brandId: number;
    uomId: string;
    updatedAt: Date;
    updatedUser: string;
    versionFlag: number;
    /**
     * 
     * @param saleOrderItemId 
     * @param saleOrderId 
     * @param itemId 
     * @param minGrade 
     * @param maxGrade 
     * @param foodTypeId 
     * @param valueAdditionOneId 
     * @param valueAdditionTwoId 
     * @param valueAdditionThreeId 
     * @param valueAdditionFourId 
     * @param cases 
     * @param netAmount 
     * @param unitPrice 
     * @param pouches 
     * @param pouchWeight 
     * @param caseWeight 
     * @param categoryId 
     * @param netWeight 
     * @param uomId 
     * @param freezeStle 
     * @param minGlaze 
     * @param MaxGlaze 
     * @param soakingTime 
     * @param soakingStyle 
     * @param styleWeighment 
     * @param varientId 
     * @param isActive 
     * @param createdAt 
     * @param createdUser 
     * @param brandId 
     * @param updatedAt 
     * @param updatedUser 
     * @param versionFlag 
     */
   
    constructor(saleOrderItemId: number,
        saleOrderId: number,
        itemId: string,
        minGrade: number,
        maxGrade: number,
        foodTypeId: string,
        valueAdditionOneId: number,
        valueAdditionTwoId: number,
        valueAdditionThreeId: number,
        valueAdditionFourId: number,
        cases: number,
        netAmount: number,
        unitPrice: number,
        pouches: number,
        pouchWeight: number,
        caseWeight: string,
        categoryId: number,
        netWeight: string,
        uomId: string,
        freezeStle: number,
        minGlaze: number,
        MaxGlaze: number,
        soakingTime: string,
        soakingStyle: string,
        styleWeighment: string,
        varientId: string,
        isActive: boolean,
        createdAt: Date,
        createdUser: string,
        brandId: number,
        updatedAt: Date,
        updatedUser: string,
        versionFlag: number,){ 
            this.saleOrderItemId = saleOrderItemId
            this.saleOrderId = saleOrderId
            this.itemId = itemId
            this.minGrade = minGrade
            this.maxGrade = maxGrade
            this.foodTypeId = foodTypeId
            this.valueAdditionOneId = valueAdditionOneId
            this.valueAdditionTwoId = valueAdditionTwoId
            this.valueAdditionThreeId = valueAdditionThreeId
            this.valueAdditionFourId = valueAdditionFourId
            this.cases = cases
            this.netAmount = netAmount
            this.unitPrice = unitPrice
            this.pouches = pouches
            this.pouchWeight = pouchWeight
            this.caseWeight = caseWeight
            this.netWeight = netWeight
            this.brandId = brandId
            this.categoryId = categoryId
            this.uomId=uomId
            this.freezeStle = freezeStle
            this.styleWeighment = styleWeighment
            this.minGlaze = minGlaze
            this.MaxGlaze = MaxGlaze
            this.soakingTime = soakingTime
            this.soakingStyle = soakingStyle
            this.varientId = varientId
            this.isActive = isActive
            this.createdAt = createdAt
            this.createdUser = createdUser
            this.updatedAt = updatedAt
            this.updatedUser = updatedUser
            this.versionFlag = versionFlag
        }
    }

    export class SOItemsDto {
        saleOrderItemId: number;
        saleOrderId: number;
        itemId: string;
        minGrade: number;
        maxGrade: number;
        foodTypeId: string;
        varientId: string;
        // valueAdditionOneId: number;
        // valueAdditionTwoId: number;
        // valueAdditionThreeId: number;
        // valueAdditionFourId: number;
        cases: number;
        netAmount: number;
        unitPrice: number;
        pouches: number;
        pouchWeight: number;
        caseWeight: number;
        categoryId: number;
        netWeight: number;
        // freezeStle: number;
            minGlaze: number;
            MaxGlaze: number;
            soakingTime: string;
            soakingStyle: string;
            styleWeighment: string;       
        brandId: number;
        brand: string;
        uomId: string;
        dispatchedQty: number;
        invAmount: number;
        currencyId: number;
        rePackQty?: number;
        reProcessQty?: number;
        productId?: number;
        shrimpWeight?:number;
        requiredQuantity?:number; //rm required Qty
        varient?:number; //rm required Qty
        hlPercentage?:number;
        finalPercentage?:number;
        jobCases?:number;
        convVariantIds?:number[];
        finalFG?:number;
        dummyStock?:number;
        balance?:number;
        variant?:number;
        masterBrandId?:number;
        netDrainedWeight?:number;
        bundleCategory?:number;
        noOfBundle?:number;
        mcPerBundle?:number;
        



        /**
         * 
         * @param saleOrderItemId 
         * @param saleOrderId 
         * @param itemId 
         * @param minGrade 
         * @param maxGrade 
         * @param foodTypeId 
         * @param valueAdditionOneId 
         * @param valueAdditionTwoId 
         * @param valueAdditionThreeId 
         * @param valueAdditionFourId 
         * @param cases 
         * @param netAmount 
         * @param unitPrice 
         * @param pouches 
         * @param pouchWeight 
         * @param caseWeight 
         * @param categoryId 
         * @param netWeight 
         * @param uomId 
         * @param freezeStle 
         * @param minGlaze 
         * @param MaxGlaze 
         * @param soakingTime 
         * @param soakingStyle 
         * @param styleWeighment 
         * @param varientId 
         * @param brandId 
       
         */
       
        constructor(saleOrderItemId: number,
            saleOrderId: number,
            itemId: string,
            minGrade: number,
            maxGrade: number,
            foodTypeId: string,
            varientId: string,
            // valueAdditionOneId: number,
            // valueAdditionTwoId: number,
            // valueAdditionThreeId: number,
            // valueAdditionFourId: number,
            cases: number,
            netAmount: number,
            unitPrice: number,
            pouches: number,
            pouchWeight: number,
            caseWeight: number,
            categoryId: number,
            netWeight: number,
            uomId: string,
            // freezeStle: number,
            minGlaze: number,
            MaxGlaze: number,
            soakingTime: string,
            soakingStyle: string,
            styleWeighment: string,
            brandId: number,brand:string,
            dispatchedQty: number,
            invAmount: number,
            currencyId: number,
            reProcessQty?: number,
            rePackQty?: number,
            productId?:number,
            shrimpWeight?:number,
            requiredQuantity?:number, //rm required Qty
            varient?:number,
            hlPercentage?:number,
            finalPercentage?:number,
            jobCases?:number,
            convVariantIds?:number[],
            finalFG?:number,
            dummyStock?:number,
            balance?:number,
            variant?:number,
            masterBrandId?:number,netDrainedWeight?:number,
            bundleCategory?:number,
            noOfBundle?:number,
            mcPerBundle?:number,
            

            ){ 
                this.saleOrderItemId = saleOrderItemId
                this.saleOrderId = saleOrderId
                this.itemId = itemId
                this.minGrade = minGrade
                this.maxGrade = maxGrade
                this.foodTypeId = foodTypeId
                this.varientId = varientId
                // this.valueAdditionOneId = valueAdditionOneId
                // this.valueAdditionTwoId = valueAdditionTwoId
                // this.valueAdditionThreeId = valueAdditionThreeId
                // this.valueAdditionFourId = valueAdditionFourId
                this.cases = cases
                this.netAmount = netAmount
                this.unitPrice = unitPrice
                this.pouches = pouches
                this.pouchWeight = pouchWeight
                this.caseWeight = caseWeight
                this.netWeight = netWeight
                this.brandId = brandId
                this.categoryId = categoryId
                this.uomId=uomId
                // this.freezeStle = freezeStle
                this.styleWeighment = styleWeighment
                this.minGlaze = minGlaze
                this.MaxGlaze = MaxGlaze
                this.soakingTime = soakingTime
                this.soakingStyle = soakingStyle
                this.brand = brand
                this.dispatchedQty = dispatchedQty
                this.invAmount = invAmount
                this.currencyId = currencyId
                this.rePackQty = rePackQty
                this.reProcessQty = reProcessQty
                this.productId = productId
                this.shrimpWeight = shrimpWeight
                this.requiredQuantity = requiredQuantity//rm required Qty
                this.varient = varient
                this.hlPercentage = hlPercentage
                this.finalPercentage = finalPercentage
                this.jobCases = jobCases
                this.convVariantIds = convVariantIds
                this.finalFG = finalFG
                this.dummyStock = dummyStock
                this.balance = balance
                this.variant = variant
                this.masterBrandId = masterBrandId
                this.netDrainedWeight = netDrainedWeight
                this.bundleCategory = bundleCategory
                this.noOfBundle = noOfBundle
                this.mcPerBundle = mcPerBundle

            }
        }
        export class soItemsGrades{

           productDescription:string
        //    code:string
           info:soItemsGradesInfo[]
            constructor(
                // code:string,
                productDescription:string,

                info:soItemsGradesInfo[]
            ){
                this.productDescription = productDescription
                // this.code = code
                this.info = info
                
            }
        }        
        export class soItemsGradesInfo{
            saleOrderItemId:number
            minGrade:number
            maxGrade:number
            quatity:number
            price:number
            noOfCases:number
            netWeight:number
            uomId : number
            revisedPrice : number
            grade : string
            itemCode : string
            grossWeightPerKg?:number
            code?:codes[]
            productionDate?:dates[]
            bestBeforeDate?:dates[]
            netAmount?:number
            invoiceAmount?:number
            bundelCategory?:boolean
            noOfBundels?:number
            gradeNames?:string
            priceUom?:number
            marksAndNo?:string

            constructor(
            saleOrderItemId:number,
                minGrade:number,
                maxGrade:number,
                quatity:number,
                price:number,
                noOfCases:number,
                netWeight:number,
                uomId : number,
                revisedPrice : number,
                grade : string,
                itemCode : string,
                grossWeightPerKg?:number,
                code?:codes[],
            productionDate?:dates[],
            bestBeforeDate?:dates[],
            netAmount?:number,
            invoiceAmount?:number,

            bundelCategory?:boolean,
            noOfBundels?:number,
            gradeNames?:string,
            priceUom?:number,
            marksAndNo?:string
  ){
                this.maxGrade = maxGrade
                this.minGrade = minGrade
                this.price = price
                this.quatity = quatity
                this.noOfCases = noOfCases
                this.netWeight = netWeight
                this.uomId = uomId
                this.revisedPrice = revisedPrice
                this.grade = grade
                this.itemCode = itemCode
                this.grossWeightPerKg = grossWeightPerKg
                this.code = code
                this.productionDate = productionDate
                this.bestBeforeDate = bestBeforeDate
                this.saleOrderItemId = saleOrderItemId
                this.netAmount=netAmount
                this.invoiceAmount=invoiceAmount
                this.bundelCategory = bundelCategory
                this.noOfBundels = noOfBundels
                this.gradeNames=gradeNames
                this.priceUom  = priceUom
                this.marksAndNo = marksAndNo
            }

        }
    export class htsCodes{
           htsCode:string
            constructor(
                htsCode:string,
            ){
                this.htsCode = htsCode
                
            }
        }
        export class codes{
            code:string
             constructor(
                 code:string,
             ){
                 this.code = code
                 
             }
         }  
           export class dates{
            date:string|Date
              constructor(
            date:string|Date
             ){
                 this.date = date
                 
             }
         }

         export class gradeNames{
            gradeNames:string
             constructor(
                 gradeNames:string,
             ){
                 this.gradeNames = gradeNames
                 
             }
            }

